import React from 'react';
import {
  IonContent,
  IonFooter,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonSpinner
} from '@ionic/react';
import StageBar from 'src/components/StageBar';
import MapModal from 'src/components/MapModal';
import Icon from 'src/components/Icon';
import app from 'src/feathers';
import alerts from 'src/lib/alerts';

export default class StageTravel extends React.Component {
  state = {
    mapView: null
  };

  async componentDidMount() {
    const { stage } = this.props;
    if (!stage.adjusted_estimate) {
      console.log('updating the adjusted_estimate');
      const travel = await app
        .service('google/distance')
        .find({
          query: {
            origins: [stage.origin_address],
            destinations: [stage.destination_address]
          }
        })
        .catch(alerts.errors);
      this.props
        .updateStage({ adjusted_estimate: travel.duration.value })
        .catch(alerts.errors);
    }
  }

  handleStageEnd = () => {
    this.props.nextStage().catch(alerts.errors);
  };

  handleOpenMap = (mapView) => {
    this.setState({ mapView });
  };

  handleCloseMap = () => {
    this.setState({ mapView: null });
  };

  render() {
    const {
      stage,
      fetching,
      job,
      stageContainer,
      startBreak,
      endBreak
    } = this.props;
    const { mapView } = this.state;
    return (
      <React.Fragment>
        <IonContent>
          <StageBar
            job={job}
            stage={stage}
            stageContainer={stageContainer}
            onStartBreak={startBreak}
            onEndBreak={endBreak}
            fetching={fetching}
          />
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol size="auto">
              <span className="dot success mr-3" />
            </IonCol>
            <IonCol>
              {stage.origin_address}
              {stage.origin_suite && (
                <p className="mb-0 ml-4">Apt/Suite: {stage.origin_suite}</p>
              )}
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2 mb-3"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol size="auto">
              <span className="dot danger mr-3" />
            </IonCol>
            <IonCol>
              {stage.destination_address}
              {stage.destination_suite && (
                <p className="mb-0 ml-4">
                  Apt/Suite: {stage.destination_suite}
                </p>
              )}
            </IonCol>
          </IonRow>
          <IonGrid>
            <IonRow className="mb-4">
              <IonCol size="6">
                <IonButton
                  onClick={() =>
                    this.handleOpenMap({
                      view: 'street',
                      center: stage.origin_address
                    })
                  }
                  color="success"
                  expand="block"
                >
                  <Icon type="street-view" className="mr-3" />
                  Origin
                </IonButton>
              </IonCol>
              <IonCol size="6">
                <IonButton
                  onClick={() =>
                    this.handleOpenMap({
                      view: 'street',
                      center: stage.destination_address
                    })
                  }
                  color="danger"
                  expand="block"
                >
                  <Icon type="street-view" className="mr-3" />
                  Destination
                </IonButton>
              </IonCol>
            </IonRow>
            <div className="mb-4">
              <IonButton
                onClick={() =>
                  this.handleOpenMap({
                    view: 'travel',
                    job: { stages: [stage] }
                  })
                }
                color="medium"
                expand="block"
              >
                <Icon type="map" className="mr-3" />
                View Map
              </IonButton>
            </div>
            <IonButton
              href={`waze://?q=${stage.destination_address}&navigate=yes`}
              color="medium"
              expand="block"
            >
              <Icon type="directions" className="mr-3" /> Get Directions
            </IonButton>
          </IonGrid>
        </IonContent>
        <IonFooter>
          <IonButton
            onClick={this.handleStageEnd}
            disabled={fetching}
            expand="full"
            className="ion-no-margin"
            color="success"
          >
            {fetching ? <IonSpinner /> : 'Next Stage'}
          </IonButton>
        </IonFooter>
        <MapModal
          isOpen={!!mapView}
          view={mapView && mapView.view}
          center={mapView && mapView.center}
          job={mapView && mapView.job}
          onClose={this.handleCloseMap}
        />
      </React.Fragment>
    );
  }
}
